import { PeerTypes } from '../../types/peers';
import { storeKeys } from '../../query-key-factory';
import { useStoreApi } from '../../api';
import { useInfiniteQuery } from '@tanstack/react-query';

import { RequestMeta } from '../../../temporary/requestmeta.types';

type PeerRecentDonation = {
  uuid: string;
  status: 'pledged' | 'purchased';
  purchased_at: string;
  name: string;
  pledged?: {
    units: string;
    amount: number;
  };
  total?: number;
  credited_to_name: string;
  participant_name?: string;
};

type PeerRecentDonationsResponse = {
  donations: PeerRecentDonation[];
  meta: RequestMeta;
};

const useListInfinitePeerRecentDonations = ({
  campaignId,
  causeId,
  uuid,
  peerType,
}: {
  campaignId: string;
  causeId: string;
  uuid: string;
  peerType: PeerTypes;
}) => {
  const StoreApi = useStoreApi();

  const getParticipantDonations = async ({
    pageParam,
  }: {
    pageParam: { limit: number; offset: number };
  }) => {
    const { limit = 10, offset = 0 } = pageParam;

    const { data } = await StoreApi.get<PeerRecentDonationsResponse>(
      `/consumer/store_items/${campaignId}/${peerType}/${uuid}/donations?cause_id=${causeId}&order[created_at]=desc&offset=${offset}&limit=${limit}`
    );
    return data;
  };

  const key = storeKeys.id('user').consumer.creditedDonations.id(uuid).all;

  return useInfiniteQuery({
    queryKey: key,
    queryFn: getParticipantDonations,
    initialPageParam: { limit: 10, offset: 0 },
    getNextPageParam: (lastPageData) => {
      const { meta } = lastPageData;
      const { has_more, limit, offset } = meta;
      if (!has_more) {
        return undefined;
      }
      return { limit, offset: offset + limit };
    },
  });
};

export { useListInfinitePeerRecentDonations };
